import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Vehicule } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class VehiculeService {

  end_url = 'vehicule'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Vehicule[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }


  get(Vehicule_id : string){
    return this.http.get<Vehicule>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + Vehicule_id)
  }

  create(data : any){
    return this.http.post<Vehicule>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : any, id : string){
    return this.http.put<Vehicule>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  checkValues(key : string, value : string){
    return new Promise<boolean>((resolve, reject) => {
      this.http.get<boolean>(this.dbConnection.remoteApiConnection.value + this.end_url + '?key='+key+'&value='+value).subscribe({
        next : (res) => resolve(res),
        error : (err) => reject("une erreur est surevenue lors de la verification de l'existance de la valeur")
      })
    })
  }

  vehiculeTracteurAssure(assure_id : string){
    return this.http.get<Vehicule[]>(this.dbConnection.remoteApiConnection.value + 'vehicule-tracteur-assure/'+assure_id)
  }


}
